import React from 'react';

/**
 * @param {{ label: React.ReactNode, required?: boolean, hint?: React.ReactNode, error?: React.ReactNode, children: React.ReactNode, className?: string }} props
 */
export default function FormField({
  label,
  required = false,
  hint,
  error,
  children,
  className = '',
}) {
  return (
    <label className={`flex flex-col gap-1 ${className}`.trim()}>
      <span className="text-xs text-dark-text-secondary">
        {label}
        {required && <span className="text-red-400 ml-0.5">*</span>}
      </span>
      {children}
      {error && <span className="text-[10px] text-red-400">{error}</span>}
      {!error && hint && <span className="text-[10px] text-dark-text-muted">{hint}</span>}
    </label>
  );
}
